import { TextField } from "@mui/material";
import { useContext } from "react";
import { exchangesValues } from "src/utils/exchangesValues";

import Context from "../context";

// ----------------------------------------------------------------------

export const FilterExchange = () => {
	const { actions, state } = useContext(Context);

	const handleOnChange = ({ target }: any) => {
		actions.onChangeFilterExchange(target.value);
	};

	return (
		<TextField
			SelectProps={{ native: true }}
			fullWidth
			size='small'
			label='Exchange'
			onChange={handleOnChange}
			select
			value={state.filterExchange ?? ""}
			sx={{ maxWidth: 120 }}
		>
			<option value='' />
			{exchangesValues.map((option, index) => (
				<option key={index} value={option}>
					{option}
				</option>
			))}
		</TextField>
	);
};

export default FilterExchange;
